import { createAction, props } from '@ngrx/store';
import type { ErrorMessage } from '../../models/error-message.model';

export const setError = createAction('[Error Handler] Set Error Message', props<Partial<ErrorMessage>>());

export const clearError = createAction('[Error Dialog] Clear Error Message');
